import {TweenLite, Power2} from "tools/gsap";

class Animator {
    constructor(options = { }) {
        this.setDefaultOptions();
        
        Object.assign(this.options, options);
    }
    
    setDefaultOptions() {
        this.options = {
            elements: { },
            duration: 0.5,
            ease: Power2.easeInOut
        };
    }
    
    duration(duration) {
        if (duration === null) {
            duration = this.options.duration;
        }
        
        return duration;
    }
    
    element(element) {
        if (typeof element === 'string') {
            element = this.options.elements[element];
        }

        return element;
    }

    to(element, props, duration = null) {
        // Make clone of object, including default ease
        props = Object.assign({
            ease: this.options.ease
        }, props);
        
        TweenLite.to(
            this.element(element),
            this.duration(duration),
            props
        );
    }
    
    fromTo(element, from, to, duration = null) {
        this.set(element, from);
        this.to(element, to, duration);
    }
    
    animate(element, props, duration = null) {
        this.to(element, props, duration);
    }

    set(element, props) {
        TweenLite.set(this.element(element), props);
    }
    
    destroy() {
        this.setDefaultOptions();
    }
}

export default Animator;